import React from 'react';
import PropTypes from 'prop-types';
import ReviewRow from '../ReviewRow';
// import { formatGroups } from '../../helpers';

function GiftCardFields({ reviewProgramDetails }) {
  const {
    program_name: programName = '-',
    // group_names: groups = [],
    entity_count: totalGiftCards = '-',
    expiry_duration: expiry = '-',
    display_amount: displayAmount = '-',
    total_amount: totalAmount = '-',
    discount: discountPercentage = '-',
    payable_amount: amountToBePaid = '-',
  } = reviewProgramDetails;

  return (
    <>
      <ReviewRow label='Plan Name' value={programName} />
      {/* <ReviewRow label='Groups' value={formatGroups(groups)} /> */}
      <ReviewRow label='Total number of gift cards' value={totalGiftCards} />
      <ReviewRow label='Expiry' value={expiry} />
      <ReviewRow label='Amount per gift card' value={displayAmount} />
      <ReviewRow label='Total Amount' value={totalAmount} />
      <ReviewRow label='Discount' value={discountPercentage} />
      <ReviewRow label='Amount to be paid' value={amountToBePaid} />
    </>
  );
}

GiftCardFields.propTypes = {
  reviewProgramDetails: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default GiftCardFields;
